

















































































import Vue from "vue";
import { proxyModel } from "@/common/utils/proxyModel";
import { MarketplaceStopSyncCreateForm } from "../forms/MarketplaceStopSyncCreateForm";
import { Shop } from "../../shop/models/Shop";

export default Vue.extend({
  props: {
    value: {
      type: Object as () => MarketplaceStopSyncCreateForm
    },
    shops: {
      type: Array as () => Shop[]
    },
    validations: {
      type: Object
    },
    state: {
      type: String
    }
  },
  computed: {
    ...proxyModel(
      "shop",
      "marketplaceName",
      "isStartImmediately",
      "fromDate",
      "untilDate"
    ),
    isUpdateState() {
      return (this as any).state === "UPDATE";
    },
    shopError() {
      return (this as any).validations.shop.$error
        ? "shop is required or invalid"
        : "";
    },
    fromDateError() {
      return (this as any).validations.fromDate.$error
        ? "from date is required or invalid"
        : "";
    },
    untilDateError() {
      return (this as any).validations.untilDate.$error
        ? "until date is required or invalid"
        : "";
    }
  }
});
